module.exports = __webpack_public_path__ + "static/media/smalleclipse.d769658e.svg";